module.exports = __webpack_public_path__ + "/96b882d6bca19a033ded097fc79dfe3e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/api_icons/api_free_icon.svg
 ** module id = 1543
 ** module chunks = 0
 **/